export const TOGGLE_BLOCK_ID = {
  directDepositSwitch: "1HOJkH2SNDdznvbZEIxcMi",
};
